export * from './lib/calendar-feature-shell.module';
